import React, { useState, useEffect } from "react";
import styles from "./index.module.less";
import picture01Image from "@/assets/images/picture01.GIF";
import picture02Image from "@/assets/images/picture02.GIF";
import picture03Image from "@/assets/images/picture03.GIF";
import picture04Image from "@/assets/images/picture04.png";

import androidCodeImg from "@/assets/images/android_1.5.0.png";
import iosCodeImg from "@/assets/images/ios_1.5.0.png";

import { downloadToolNow } from "@/utils/constants.js";

export default function (props) {
  const [previewEWM, setPreviewEWM] = useState(
    [
      {
        id: 1,
        icon: iosCodeImg,
        desc: 'iOS预览版'
      },
      {
        id: 2,
        icon: androidCodeImg,
        desc: 'Android预览版'
      },
    ]
  );

  useEffect(() => {}, []);

  return (
    <div className={styles.main}>
      <div className={styles.title}>用AR特效来描绘世界</div>
      <div>
        <div className={styles.desc}>
        Effects Studio是一个专注于特效创作的开放平台，为特效设计师提供高效、快捷、实用的特效创作工具。在这里，你可以随心所欲地发挥想象，用特效来表达想法，将AR和真实世界相连。
        </div>
      </div>
      <div>
        <video
          className={styles.video}
          // controls
          muted
          autoPlay
          loop
          src="/video.mp4"
          type="video/mp4"
        >
          浏览器不支持
        </video>
      </div>
      <div className={styles.tool}>专业好用的创作工具</div>
      <div className={styles["tool-desc"]}>
      Effects Studio，让特效设计变得简单
      </div>
      <div className={styles["tool-download"]}>
        <span onClick={downloadToolNow}>下载创作工具</span>
      </div>
      <img className={styles.picture01} src={picture01Image} />
      <div className={styles.design}>特效设计，从这里开始</div>

      <div className={styles["step-one"]}>
        <div className={styles["step-one-left"]}>
          <div className={styles["step-one-left-title"]}>
          Step1 导入您的创意
          </div>
          <div className={styles["step-one-left-desc"]}>
          使用您常用的2D/3D设计工具进行创意，并将创意素材导入Effects Studio
          </div>
        </div>
        <img className={styles.picture02} src={picture02Image} />
      </div>

      <div className={styles["step-two"]}>
        <img className={styles.picture03} src={picture03Image} />
        <div className={styles["step-two-right"]}>
          <div className={styles["step-two-right-title"]}>
            Step2 将创意转换为特效
          </div>
          <div className={styles["step-two-right-desc"]}>
          从一个特效模版入手，或者一点点通过Effects Studio拼接创意。搭配使用3DMesh、分割等高阶功能，设计有趣好玩的AR特效
          </div>
        </div>
      </div>

      <div className={styles["step-three"]}>
        <div className={styles["step-three-left"]}>
          <div className={styles["step-three-left-title"]}>
          Step3 预览并发布
          </div>
          <div className={styles["step-three-left-desc"]}>
          导出并提交特效！将特效上传到平台，让更多的用户感受你的创意
          </div>
          <div className={styles["step-three-left-scan"]}>
          扫码下载SenseAR
          </div>
          <div className={styles["step-three-left-preview"]}>
            {
              previewEWM.map(item => (
                <div className={styles["step-three-left-preview-item"]} key={item.id}>
                  <img src={item.icon} />
                  <span>{item.desc}</span>
                </div>
              ))
            }
          </div>
        </div>
        <img className={styles.picture04} src={picture04Image} />
      </div>

    </div>
  );
}
